module.exports = __webpack_public_path__ + "media/assets/icon_email_blue_outline-000100ad89581742780b25be96823ef344610006eb0b516eee1b7a9debdfd031.svg";